<div
  class="lc-table-shell"
  [class.lc-table-shell--refreshing]="loading && hasRows"
>
  <div
    *ngIf="loading && hasRows"
    class="lc-table-shell__overlay"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="lc-table-shell__loader">
      <span class="lc-table-shell__spinner" aria-hidden="true"></span>
      <span>{{ refreshMessage }}</span>
    </div>
  </div>
  <ng-content></ng-content>
</div>
